// Country name to ISO 3166-1 alpha-2 code mapping for Apple emoji flag images
export const countryToFlagCode: Record<string, string> = {
  // Both names map to the same flag. The old key stays so every profile
  // already saved as 'Soulaan' keeps resolving after the rename.
  'Soulaan': 'soulaan',
  'Black American/Soulaan': 'soulaan',
  
  // African Countries
  'Nigeria': 'ng',
  'Ghana': 'gh',
  'South Africa': 'za',
  'Kenya': 'ke',
  'Ethiopia': 'et',
  'Tanzania': 'tz',
  'Egypt': 'eg',
  'Morocco': 'ma',
  'Algeria': 'dz',
  'Uganda': 'ug',
  'Cameroon': 'cm',
  'Senegal': 'sn',
  'Rwanda': 'rw',
  'Tunisia': 'tn',
  'Zimbabwe': 'zw',
  'Botswana': 'bw',
  'Ivory Coast': 'ci',
  'Zambia': 'zm',
  'Mozambique': 'mz',
  'Mali': 'ml',
  'Burkina Faso': 'bf',
  'Niger': 'ne',
  'Angola': 'ao',
  'Somalia': 'so',
  'Chad': 'td',
  'Sudan': 'sd',
  'Benin': 'bj',
  'Togo': 'tg',
  'Sierra Leone': 'sl',
  'Liberia': 'lr',
  'Namibia': 'na',
  'Mauritius': 'mu',
  'Madagascar': 'mg',
  'Malawi': 'mw',
  'Gabon': 'ga',
  'Mauritania': 'mr',
  'Guinea': 'gn',
  'Burundi': 'bi',
  'Eritrea': 'er',
  'Gambia': 'gm',
  'Lesotho': 'ls',
  'eSwatini': 'sz',
  'Djibouti': 'dj',
  'Congo': 'cg',
  'DR Congo': 'cd',
  'Libya': 'ly',
  'Seychelles': 'sc',
  'Cape Verde': 'cv',
  'Comoros': 'km',
  'Guinea-Bissau': 'gw',
  'Equatorial Guinea': 'gq',
  'SÃ£o TomÃ©': 'st',
  'South Sudan': 'ss',
  'CAR': 'cf',
  
  // Caribbean Nations
  'Jamaica': 'jm',
  'Belize': 'bz',
  'Guyana': 'gy',
  'Suriname': 'sr',
  'Trinidad and Tobago': 'tt',
  'Trinidad & Tobago': 'tt',
  'Haiti': 'ht',
  'Barbados': 'bb',
  // Pickable heritages that had no entry here, so their flag never resolved from
  // a stored profile value.
  'São Tomé': 'st',
  'Sao Tome': 'st',
  // 'Republic of New Afrika' is mapped further down with its 'New Afrikan'
  // alias; not repeated here.
  // Spellings used by the browse list and by older stored profiles. Aliases only
  // ever help resolution: a name reaches the right flag whichever way it was
  // written when it was saved.
  'Saint Vincent': 'vc',
  'Antigua': 'ag',
  'Curaçao': 'cw',
  'Saint Helena, Ascension and Tristan da Cunha': 'sh',
  'British Virgin Islands': 'vi',
  'Guadeloupe': 'gp',
  'Martinique': 'mq',
  'French Guiana': 'gf',
  'Puerto Rico': 'pr',
  'Curacao': 'cw',
  'Aruba': 'aw',
  'Bonaire': 'bq',
  'Bermuda': 'bm',
  'Cayman Islands': 'ky',
  'Turks and Caicos Islands': 'tc',
  'US Virgin Islands': 'vi',
  'Anguilla': 'ai',
  'Montserrat': 'ms',
  'Mayotte': 'yt',
  'Saint Helena': 'sh',
  'Bahamas': 'bs',
  'Grenada': 'gd',
  'Saint Lucia': 'lc',
  'Saint Kitts and Nevis': 'kn',
  'Dominica': 'dm',
  'Saint Vincent and the Grenadines': 'vc',
  'Antigua and Barbuda': 'ag',
  
  // Diaspora (using their host country codes)
  'America': 'us',
  'American': 'us',
  'Black American': 'us',
  'European Africans': 'eu',
  'UK Africans': 'gb',
  'Canada': 'ca',
  'Canadians': 'ca',
  'Black Canadian': 'ca',
  'Canada Africans': 'ca',
  'France Africans': 'fr',
  'Brazillians': 'br',
  'Black Brazilian': 'br',
  'Brazil Africans': 'br',
  'Brazil': 'br',
  'Republic of New Afrika': 'rna',
  'New Afrikan': 'rna',
  'Gullah Geechie': 'gg',
  
  // Major Host/Other Countries
  'United States': 'us',
  'United Kingdom': 'gb',
  'France': 'fr',
  'Germany': 'de',
  'Australia': 'au',
  'Netherlands': 'nl',
  'Belgium': 'be',
  'Portugal': 'pt',
  'Spain': 'es',
  'Italy': 'it',
  'Sweden': 'se',
  'Norway': 'no',
  'Denmark': 'dk',
  'Switzerland': 'ch',
  'Austria': 'at',
  'India': 'in',
  'China': 'cn',
  'Japan': 'jp',
  'South Korea': 'kr',
  'Mexico': 'mx',
  'Argentina': 'ar',
  'Chile': 'cl',
  'Colombia': 'co',
  'Peru': 'pe',
  'Venezuela': 've',
  'UAE': 'ae',
  'Saudi Arabia': 'sa',
  'Turkey': 'tr',
  'Russia': 'ru',
  'Poland': 'pl',
  'Ireland': 'ie',
  'New Zealand': 'nz',
  'Singapore': 'sg',
  'Malaysia': 'my',
  'Thailand': 'th',
  'Indonesia': 'id',
  'Philippines': 'ph',
  'Vietnam': 'vn',
  
  // New Global Mappings
  'Pakistan': 'pk',
  'Israel': 'il',
  'Qatar': 'qa',
  'Oman': 'om',
  'Yemen': 'ye',
  'Afghanistan': 'af',
  'Albania': 'al',
  'Bangladesh': 'bd',
  'Romania': 'ro',
  'Ukraine': 'ua',
  'Greece': 'gr',
  'Finland': 'fi',
  'Iceland': 'is',
  'Costa Rica': 'cr',
  'Cuba': 'cu',
  'Dominican Republic': 'do',
  'Panama': 'pa',
  'Uruguay': 'uy',
  'Paraguay': 'py',
  'Bolivia': 'bo',
  'Ecuador': 'ec',
  'Fiji': 'fj',
  'Papua New Guinea': 'pg',
  'Samoa': 'ws',
  'Tonga': 'to',
  'Vanuatu': 'vu',
  'Palestine': 'ps'
};

// Convert country code to Unicode flag emoji codepoints for Twemoji
function getUnicodeFlagCodepoint(countryCode: string): string {
  // Convert country code to regional indicator symbols
  // For example: 'ng' -> '1f1f3-1f1ec' (Nigeria flag)
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => {
      // Regional Indicator Symbol Letter A starts at U+1F1E6 (127462)
      // 'A'.charCodeAt(0) is 65
      const offset = char.charCodeAt(0) - 65;
      const regionalIndicator = 0x1F1E6 + offset;
      return regionalIndicator.toString(16);
    })
    .join('-');
  
  return codePoints;
}

// Helper function to get flag image URL from local assets with CDN fallback
export function getFlagUrl(countryName: string, size: 'w20' | 'w40' | 'w80' | 'w160' = 'w80'): string {
  const code = (countryToFlagCode[countryName] || (countryName?.length >= 2 && countryName?.length <= 10 ? countryName.toLowerCase() : undefined));
  
  if (code) {
    // 1. Try local asset
    const localFlag = getFlagImage(code);
    if (localFlag) return localFlag;
    
    // 2. Local fallback log
    console.warn(`[Flags] Missing local flag asset for code: ${code}`);
  }
  
  // 3. Last resort: Blank transparent SVG
  return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="32" height="24"%3E%3C/svg%3E';
}

// Helper to get real emoji character
export function getEmojiFlag(countryName: string): string {
  const code = countryToFlagCode[countryName];
  if (!code || code.length !== 2) return 'ðŸŒ';
  
  return code
    .toUpperCase()
    .replace(/./g, char => 
      String.fromCodePoint(char.charCodeAt(0) + 127397)
    );
}

import { getFlagImage, flagImages } from '../../assets/flags';

// Component for rendering flag images
interface FlagImageProps {
  countryName: string;
  size?: 'w20' | 'w40' | 'w80' | 'w160';
  className?: string;
  alt?: string;
}
// Helper to extract country code from emoji
function getCountryCodeFromEmoji(emoji: string): string | undefined {
  if (!emoji) return undefined;
  
  // Check for regional indicator symbols (flag emojis)
  const regex = /[\uD83C][\uDDE6-\uDDFF][\uD83C][\uDDE6-\uDDFF]/;
  if (regex.test(emoji)) {
    const chars = Array.from(emoji);
    if (chars.length >= 2) {
      const code = chars.map(char => {
        const cp = char.codePointAt(0);
        if (cp && cp >= 0x1F1E6 && cp <= 0x1F1FF) {
          return String.fromCharCode(cp - 0x1F1E6 + 65);
        }
        return '';
      }).join('').toLowerCase();
      return code.length === 2 ? code : undefined;
    }
  }
  return undefined;
}

export function FlagImage({ countryName, size = 'w80', className = '', alt, ...props }: FlagImageProps & React.ImgHTMLAttributes<HTMLImageElement>) {
  // 1. Resolve Code (from Name, Code, or Emoji)
  // First check if it's already a direct code mapping (2 or 3 letters usually, but we allow up to 10 for custom identities like 'soulaan')
  let code = (countryToFlagCode[countryName] || (countryName?.length >= 2 && countryName?.length <= 10 ? countryName.toLowerCase() : undefined));
  
  // Try fuzzy match if no code found yet
  if (!code && countryName) {
    const lowerName = countryName.toLowerCase().trim();
    const match = Object.entries(countryToFlagCode).find(([k]) => k.toLowerCase() === lowerName);
    if (match) {
        code = match[1];
    }
  }

  // Final check: if it's a code, does it exist in our flagImages?
  if (code && !flagImages[code.toLowerCase()]) {
      // If we have a code but no image, maybe it's actually a country name that didn't match
      // This is a safety net
  }

  let flagUrl = code ? getFlagImage(code) : undefined;
  
  // Last resort: try emoji extraction if name contains an emoji
  if (!flagUrl && countryName) {
    const emojiCode = getCountryCodeFromEmoji(countryName);
    if (emojiCode) flagUrl = getFlagImage(emojiCode);
  }

  // Default to blank if still nothing
  if (!flagUrl) {
    const fallbackUrl = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="32" height="24"%3E%3C/svg%3E';
    return <img src={fallbackUrl} alt={alt || countryName} className={className} />;
  }
  
  // 5. Special scaling for the PNG heritage flags (Soulaan, New Afrikan, Gullah
  // Geechie). These are waving-emoji artwork rather than the flat rectangles the
  // SVG flags use, so they are scaled down to sit at the same visual size. The
  // factor is per-asset because the wave silhouettes are not identical.
  //
  // MEASURED, not guessed. All three sit on an identical 160x120 canvas, and
  // what differs is how much of it the artwork actually covers. Run
  //
  //     node scripts/measureFlagArtwork.cjs src/assets/flags/*.png
  //
  // which reports the opaque bounding box, and re-derive the factor from that.
  // The numbers below come from that script at an alpha threshold of 220:
  //
  //     soulaan.png                159x119   99.4%w  99.2%h
  //     gullah_geechie.png         159x119   99.4%w  99.2%h
  //     republic_of_new_afrika.png 156x109   97.5%w  90.8%h
  //
  // New Afrikan's artwork is ~8% shorter inside the same canvas, so it needs a
  // correspondingly larger factor to end up the same size on screen. The prose
  // that used to be here quoted 158x118 and 155x108, neither of which matches
  // the files any more — the assets were re-exported and the comment was not,
  // which is exactly why the measurement is now a script rather than a memory.
  const pngHeritageFlagScales: Record<string, number> = {
    soulaan: 0.82,
    gg: 0.82,
    ggm: 0.82,
    // 0.82 / 0.908 ≈ 0.90 matches it on HEIGHT alone, which is what the previous
    // value did, but it still read as the smaller flag beside the others. Raised
    // so the visible artwork carries the same weight rather than merely the same
    // bounding box. One number to nudge if it wants to be bigger or smaller.
    rna: 0.98,
  };
  const scale = (code && pngHeritageFlagScales[code.toLowerCase()]) || 1.0;

  return (
    <img
      src={flagUrl}
      alt={alt || `${countryName} flag`}
      className={`${className} object-cover`}
      style={{
        imageRendering: '-webkit-optimize-contrast',
        willChange: 'transform',
        transform: scale !== 1.0 ? `translateZ(0) scale(${scale})` : 'translateZ(0)',
        ...((props as any).style || {})
      }}
      loading="lazy"
      onError={(e) => {
        // Log if local SVG fails to load
        console.warn(`[Flags] Failed to load local flag asset: ${flagUrl}`);
      }}
    />
  );
}

// All countries list for dropdown selection
export const allCountries = [
  { name: 'Black American/Soulaan', code: 'soulaan' },
  // African Countries
  { name: 'Algeria', code: 'dz' },
  { name: 'Angola', code: 'ao' },
  { name: 'Benin', code: 'bj' },
  { name: 'Botswana', code: 'bw' },
  { name: 'Burkina Faso', code: 'bf' },
  { name: 'Burundi', code: 'bi' },
  { name: 'Cameroon', code: 'cm' },
  { name: 'Cape Verde', code: 'cv' },
  { name: 'CAR', code: 'cf' },
  { name: 'Chad', code: 'td' },
  { name: 'Comoros', code: 'km' },
  { name: 'Congo', code: 'cg' },
  { name: 'DR Congo', code: 'cd' },
  { name: 'Djibouti', code: 'dj' },
  { name: 'Egypt', code: 'eg' },
  { name: 'Equatorial Guinea', code: 'gq' },
  { name: 'Eritrea', code: 'er' },
  { name: 'eSwatini', code: 'sz' },
  { name: 'Ethiopia', code: 'et' },
  { name: 'Gabon', code: 'ga' },
  { name: 'Gambia', code: 'gm' },
  { name: 'Ghana', code: 'gh' },
  { name: 'Guinea', code: 'gn' },
  { name: 'Guinea-Bissau', code: 'gw' },
  { name: 'Ivory Coast', code: 'ci' },
  { name: 'Kenya', code: 'ke' },
  { name: 'Lesotho', code: 'ls' },
  { name: 'Liberia', code: 'lr' },
  { name: 'Libya', code: 'ly' },
  { name: 'Madagascar', code: 'mg' },
  { name: 'Malawi', code: 'mw' },
  { name: 'Mali', code: 'ml' },
  { name: 'Mauritania', code: 'mr' },
  { name: 'Mauritius', code: 'mu' },
  { name: 'Morocco', code: 'ma' },
  { name: 'Mozambique', code: 'mz' },
  { name: 'Namibia', code: 'na' },
  { name: 'Niger', code: 'ne' },
  { name: 'Nigeria', code: 'ng' },
  { name: 'Rwanda', code: 'rw' },
  { name: 'SÃ£o TomÃ©', code: 'st' },
  { name: 'Senegal', code: 'sn' },
  { name: 'Seychelles', code: 'sc' },
  { name: 'Sierra Leone', code: 'sl' },
  { name: 'Somalia', code: 'so' },
  { name: 'South Africa', code: 'za' },
  { name: 'South Sudan', code: 'ss' },
  { name: 'Sudan', code: 'sd' },
  { name: 'Tanzania', code: 'tz' },
  { name: 'Togo', code: 'tg' },
  { name: 'Tunisia', code: 'tn' },
  { name: 'Uganda', code: 'ug' },
  { name: 'Zambia', code: 'zm' },
  { name: 'Zimbabwe', code: 'zw' },
  
  // Caribbean Nations
  { name: 'Antigua and Barbuda', code: 'ag' },
  { name: 'Bahamas', code: 'bs' },
  { name: 'Barbados', code: 'bb' },
  { name: 'São Tomé', code: 'st' },
  { name: 'Palestine', code: 'ps' },
  { name: 'Israel', code: 'il' },
  { name: 'Republic of New Afrika', code: 'rna' },
  { name: 'Guadeloupe', code: 'gp' },
  { name: 'Martinique', code: 'mq' },
  { name: 'French Guiana', code: 'gf' },
  { name: 'Puerto Rico', code: 'pr' },
  { name: 'Curacao', code: 'cw' },
  { name: 'Aruba', code: 'aw' },
  { name: 'Bonaire', code: 'bq' },
  { name: 'Bermuda', code: 'bm' },
  { name: 'Cayman Islands', code: 'ky' },
  { name: 'Turks and Caicos Islands', code: 'tc' },
  { name: 'US Virgin Islands', code: 'vi' },
  { name: 'Anguilla', code: 'ai' },
  { name: 'Montserrat', code: 'ms' },
  { name: 'Mayotte', code: 'yt' },
  { name: 'Saint Helena', code: 'sh' },
  { name: 'Dominica', code: 'dm' },
  { name: 'Dominican Republic', code: 'do' },
  { name: 'Grenada', code: 'gd' },
  { name: 'Haiti', code: 'ht' },
  { name: 'Jamaica', code: 'jm' },
  { name: 'Saint Kitts and Nevis', code: 'kn' },
  { name: 'Saint Lucia', code: 'lc' },
  { name: 'Saint Vincent and the Grenadines', code: 'vc' },
  { name: 'Trinidad and Tobago', code: 'tt' },
  { name: 'Belize', code: 'bz' },
  { name: 'Cuba', code: 'cu' },
  { name: 'Guyana', code: 'gy' },
  { name: 'Suriname', code: 'sr' },
  
  // Other Major Countries (for diaspora)
  { name: 'United States', code: 'us' },
  { name: 'United Kingdom', code: 'gb' },
  { name: 'Canada', code: 'ca' },
  { name: 'France', code: 'fr' },
  { name: 'Germany', code: 'de' },
  { name: 'Brazil', code: 'br' },
  { name: 'Australia', code: 'au' },
  { name: 'Netherlands', code: 'nl' },
  { name: 'Belgium', code: 'be' },
  { name: 'Portugal', code: 'pt' },
  { name: 'Spain', code: 'es' },
  { name: 'Italy', code: 'it' },
  { name: 'Sweden', code: 'se' },
  { name: 'Norway', code: 'no' },
  { name: 'Denmark', code: 'dk' },
  { name: 'Switzerland', code: 'ch' },
  { name: 'Austria', code: 'at' },
  { name: 'India', code: 'in' },
  { name: 'China', code: 'cn' },
  { name: 'Japan', code: 'jp' },
  { name: 'South Korea', code: 'kr' },
  { name: 'Mexico', code: 'mx' },
  { name: 'Argentina', code: 'ar' },
  { name: 'Chile', code: 'cl' },
  { name: 'Colombia', code: 'co' },
  { name: 'Peru', code: 'pe' },
  { name: 'Venezuela', code: 've' },
  { name: 'UAE', code: 'ae' },
  { name: 'Saudi Arabia', code: 'sa' },
  { name: 'Turkey', code: 'tr' },
  { name: 'Russia', code: 'ru' },
  { name: 'Poland', code: 'pl' },
  { name: 'Ireland', code: 'ie' },
  { name: 'New Zealand', code: 'nz' },
  { name: 'Singapore', code: 'sg' },
  { name: 'Malaysia', code: 'my' },
  { name: 'Thailand', code: 'th' },
  { name: 'Indonesia', code: 'id' },
  { name: 'Philippines', code: 'ph' },
  { name: 'Vietnam', code: 'vn' },
  { name: 'New Afrikan', code: 'rna' },
  { name: 'Gullah Geechie', code: 'gg' },
].sort((a, b) => a.name.localeCompare(b.name));

/**
 * Resolves a country name (or code) to a bundled flag image URL.
 *
 * Extracted so non-React renderers — the yap image export — can obtain the same
 * flag the FlagImage component would show, instead of duplicating the
 * name-to-code matching and drifting from it. Flags are local bundle assets, so
 * the result is safe to draw onto a canvas without tainting it.
 */
export function resolveFlagUrl(countryName?: string): string | undefined {
  if (!countryName) return undefined;
  let code = countryToFlagCode[countryName]
    || (countryName.length >= 2 && countryName.length <= 10 ? countryName.toLowerCase() : undefined);

  if (!code) {
    const lower = countryName.toLowerCase().trim();
    const match = Object.entries(countryToFlagCode).find(([k]) => k.toLowerCase() === lower);
    if (match) code = match[1];
  }

  return code ? getFlagImage(code) : undefined;
}
